import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type StoreSearchFilterProps = {
    storeFeature: string;
    active: boolean;
    onToggle: (filter: string) => void;
};

const StoreSearchFilter = ({
    storeFeature,
    active,
    onToggle
}: StoreSearchFilterProps) => {
    const { t } = useGranite();

    const handleOnChange = () => onToggle(storeFeature);

    return (
        <li className={cn("tw:flex tw:gap-2 tw:items-center")}>
            <input
                className={cn("tw:ml-1")}
                id={`storeSearchFilter--${storeFeature}`}
                type="checkbox"
                checked={active}
                onChange={handleOnChange}
            />
            <label
                className={cn("tw:m-0 tw:py-1")}
                htmlFor={`storeSearchFilter--${storeFeature}`}
            >
                {t(`form.searchstore.filter.${storeFeature}`)}
            </label>
        </li>
    );
};

export { StoreSearchFilter };
